import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export function isSameDay(
  a: Date | null | undefined,
  b: Date | null | undefined
) {
  if (a == null || b == null) {
    return a == null && b == null;
  }
  return dayjs.utc(a).isSame(dayjs.utc(b), 'day');
}
